export const newsBanner = 'Banner de noticias';
export const newsBannerTitle = 'Título';
export const newsBannerBody = 'Cuerpo';
export const isVisible = '¿Habilitado?';
export const createNewsBanner = 'Crear banner de noticias';
export const save = 'Guardar';
export const createSuccess = 'Banner de noticias creado exitosamente';
export const updateSuccess = 'Banner de noticias actualizado exitosamente';
export const error = 'Error al realizar la operación';
